// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a5350718","488":"6946e9cf"}[chunkId] + ".chunk.js";
};